import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100% ',
    display: 'flex',
    
    justifyContent: 'flex-start',
    flexDirection: 'column',
    gap: '1rem',
    '& p > span': {
      fontWeight: 600,
    },

    '& p > a': {
      color: Colors.loginLigthenPrimaryColor,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
  },

  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },

  additionalQuestions: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: '1rem',
  },

  prospectData: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  textCapitalize: {
    textTransform: 'capitalize',
  },
  title: {
    width: '100%',
    color: Colors.white,
    backgroundColor: Colors.primaryColor,
    fontWeight: '600',
    textAlign: 'center',
    fontSize: '1.6rem',
    padding: '0.5rem',
    borderRadius: 5,
    margin: 0,
  },
}))

export default styles
